import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserResourceRepositoryImpl } from "../../data/repository/user_resource_repository_impl";
import { ResourceInterface } from "../interface/resource_interface";
import { FavoriteResourceInterface } from "../interface/favorite_resource_interface";

export const useMarkResourceAsViewed = () => {
  const repository = new UserResourceRepositoryImpl();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (resourceId: string) => {
      await repository.markResourceAsViewed({ _resourceId: resourceId });
    },
    onSuccess: (_, resourceId) => {
      queryClient.setQueryData<ResourceInterface | undefined>(
        ["resourceById", resourceId],
        (old) => (old ? { ...old, viewed: true } : old)
      );

      queryClient.setQueriesData<ResourceInterface[] | undefined>(
        { queryKey: ["resourceByThemeId"], exact: false },
        (old) =>
          old
            ? old.map((r) => (r._id === resourceId ? { ...r, viewed: true } : r))
            : old
      );

      queryClient.setQueriesData<FavoriteResourceInterface[] | undefined>(
        { queryKey: ["favoritesByUserIdAndThemeId"], exact: false },
        (old) =>
          old
            ? old.map((f) =>
                f._resourceId?._id === resourceId
                  ? { ...f, viewed: true, _resourceId: { ...f._resourceId, viewed: true } }
                  : f
              )
            : old
      );
    },
  });
};
